/* Buffalo House review hierarchy, semantic features and critic-ticket cleanup. */
(function () {
  'use strict';

  var scheduled = false;

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function criticCode(raw) {
    var value = String(raw || '').trim().toUpperCase();
    var codes = {
      'WHA': 'WA',
      'WHISKEY ADVOCATE': 'WA',
      'WHISKY ADVOCATE': 'WA',
      'WA': 'WA',
      'WINE ENTHUSIAST': 'WE',
      'WE': 'WE',
      'WINE SPECTATOR': 'WS',
      'WS': 'WS',
      'JAMES SUCKLING': 'JS',
      'JS': 'JS',
      'DECANTER': 'DE',
      'D': 'DE',
      'DE': 'DE'
    };
    return codes[value] || value.slice(0, 2);
  }

  function featureTone(raw) {
    var value = String(raw || '').trim().toLowerCase();
    if (/sustainab|vegan|organic|natural/.test(value)) return 'green';
    if (/zero sugar|100% agave|agave/.test(value)) return 'yellow';
    if (/low calorie/.test(value)) return 'orange';
    if (/kosher|non-chill|non chill/.test(value)) return 'purple';
    if (/unoaked/.test(value)) return 'coral';
    if (/gluten/.test(value)) return 'blue';
    return 'blue';
  }

  function decorateCritics(root) {
    all('.product-card__critic, .product-enrichment .critic-score', root).forEach(function (ticket) {
      var source = ticket.querySelector('.product-card__critic-source, .critic-score__source');
      if (!source) return;
      var code = criticCode(source.textContent);
      if (source.textContent.trim() !== code) source.textContent = code;
      ticket.setAttribute('data-critic-source', code);
    });
  }

  function decorateFeatures(root) {
    all('.product-card__feature, .product-enrichment__features .feature-chip', root).forEach(function (feature) {
      var label = feature.getAttribute('title') || feature.textContent || '';
      feature.setAttribute('data-feature-tone', featureTone(label));
    });
  }

  function shortenStockCopy(infoCard) {
    var stock = infoCard && infoCard.querySelector('[data-stock-note]');
    if (!stock || stock.classList.contains('stock-note--out')) return;
    var text = stock.querySelector('span:last-child');
    if (text && text.textContent.trim() !== 'In stock') text.textContent = 'In stock';
  }

  function arrangePdp() {
    var infoCard = document.querySelector('.pdp-info-card');
    if (!infoCard) return;

    var title = infoCard.querySelector('.pdp-title');
    var vendor = infoCard.querySelector('.pdp-vendor');
    var badge = infoCard.querySelector('.jdgm-prev-badge');
    var badgeBlock = badge && (badge.closest('.jdgm-widget') || badge);

    if (title && badgeBlock && badgeBlock.parentNode === infoCard && badgeBlock.nextElementSibling !== title) {
      infoCard.insertBefore(badgeBlock, title);
    }

    if (title && vendor && vendor.previousElementSibling !== title) {
      title.insertAdjacentElement('afterend', vendor);
    }

    all('.pdp-awards .badge--outline', infoCard).forEach(function (oldReviewBadge) {
      if (/review/i.test(oldReviewBadge.textContent || '')) oldReviewBadge.remove();
    });

    shortenStockCopy(infoCard);
  }

  function refine(root) {
    decorateCritics(root || document);
    decorateFeatures(root || document);
    arrangePdp();
  }

  function queueRefine() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      refine(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refine(document); }, { once: true });
  } else {
    refine(document);
  }

  var observer = new MutationObserver(queueRefine);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  window.setTimeout(queueRefine, 500);
  window.setTimeout(queueRefine, 1600);
  window.setTimeout(queueRefine, 3200);
})();
